import {useSearchParams, useNavigate, useLocation} from 'react-router-dom'
import React, {useState, useEffect} from 'react'
import axios from 'axios'
import {defaultpropsalertform} from 'entries/alertform'
import {ProgressFullScreen} from 'molecules'
import AlertForm from 'template/Form/AlertForm'
import {VmView} from 'components'
import QueryString from 'qs'
import {ModalCariEtiket} from 'pages/prd-data-racikan/modal-etiket'
import {Controller, FormProvider, useForm} from 'react-hook-form'
import {TextField} from './TextField'

// --------------------------------------------

const inputForm = [
  {name: 'obatkode', label: 'Kode Obat', required: true},
  {name: 'obatnama', label: 'Nama Obat', required: true},
  {name: 'obatdeskripsi', label: 'Deskripsi'},
  {name: 'obatindikasi', label: 'Indikasi'},
  {name: 'obatkandungan', label: 'Kandungan'},
  {name: 'obatdosis', label: 'Dosis'},
  {name: 'obatkontraindikasi', label: 'Kontraindikasi'},
  {name: 'obatkemasan', label: 'Kemasan / Bentuk Sediaan'},
  {name: 'obatefeksamping', label: 'Efek Samping'},
  {name: 'obatzat', label: 'Zat Aktif Prekursor'},
  {name: 'obatetiketcatatan', label: 'Etiket/Aturan Pakai'},
]

// --------------------------------------------

const defaultSatuanObat = {
  sodid: 0,
  soid: '',
  konversi: 1,
  hna: 0,
  hj1: 0,
  hj2: 0,
  hj3: 0,
  diskon1: 0,
  diskon2: 0,
  diskon3: 0,
  barcode: '',
}

// --------------------------------------------

export default function PrdDataObatUpdate({
  successLabel = 'Berhasil Menyimpan data',
  errorLabel = 'Terjadi kesalahan saat menyimpan data',
}) {
  const [searchParams] = useSearchParams()
  const uid = searchParams.get('dctid')
  const obatid = searchParams.get('obatid')
  const navigate = useNavigate()
  const location = useLocation()
  const initialData = location?.state?.item || ''
  const label = initialData ? 'Ubah Data Obat' : 'Tambah Data Obat'

  const [form, setForm] = useState(initialData)
  const [loading, setLoading] = useState(false)
  const [propsalertform, setpropsalertform] = useState(defaultpropsalertform)
  const [isModalOpen, setModalOpen] = useState(false)
  const [dataEtiket, setDataEtiket] = useState([])
  const [dataSatuan, setDataSatuan] = useState([])

  const openModal = () => setModalOpen(true)
  const closeModal = () => setModalOpen(false)

  const methods = useForm({
    defaultValues: {
      obatkode: initialData?.obatkode ?? '',
      obatnama: initialData?.obatnama ?? '',
      obatdeskripsi: initialData?.obatdeskripsi ?? '',
      obatindikasi: initialData?.obatindikasi ?? '',
      obatkandungan: initialData?.obatkandungan ?? '',
      obatdosis: initialData?.obatdosis ?? '',
      obatkontraindikasi: initialData?.obatkontraindikasi ?? '',
      obatkemasan: initialData?.obatkemasan ?? '',
      obatefeksamping: initialData?.obatefeksamping ?? '',
      obatzat: initialData?.obatzat ?? '',
      obatetiketcatatan: initialData?.obatetiketcatatan ?? '',
      satuanObat: initialData?.satuanObat ?? [defaultSatuanObat],
    },
  })

  const {control, handleSubmit, setValue, getValues, reset} = methods

  const closeAlert = () => setpropsalertform(defaultpropsalertform)
  const openAlert = (caption, type, onConfirm = closeAlert) => {
    setpropsalertform({
      ...propsalertform,
      type,
      visible: true,
      children: <>{caption}</>,
      onConfirm: onConfirm,
      onClose: closeAlert,
      onCancel: closeAlert,
    })
  }

  const onSubmit = async data => {
    setLoading(true)

    try {
      const result = await axios.post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-obat/update',
        QueryString.stringify({
          a: 'dk13',
          reg: 'dbdok',
          uid,
          obatid,
          data,
        })
      ).then(({data}) => data)

      if (result?.status === 1) {
        openAlert('Berhasil mengubah data', 1, () => navigate('/prd-data-obat?dctid=' + uid))
      } else {
        openAlert(data?.message || successLabel, 1, () => {})
      }
    } catch (err) {
      openAlert('[EC-8] ' + errorLabel, 3)
    } finally {
      setLoading(false)
    }
  }

  const fetchEtiket = async () => {
    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-etiket/index',
        QueryString.stringify({
          a: 'dk13',
          reg: 'dbdok',
          uid,
          etiaktif: 1,
          etiketerangan: '',
          etinama: '',
          limit: 1000,
          offset: 0,
        })
      )
      .then(({data: res}) => {
        if (res) {
          setDataEtiket(res)
        } else {
          console.log('Error get Data Etiket')
        }
      })
      .catch(err => {
        console.log('Error get Data Etiket', err.message)
      })
      .finally(() => {
        // this.setState({gettingInitialData: false})
      })
  }

  const fetchSatuan = () => {
    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-satuan/index',
        QueryString.stringify({
          a: 'dk13',
          reg: 'dbdok',
          uid,
          offset: 0,
          soaktif: 1,
          sonama: '',
          limit: 10000,
        })
      )
      .then(({data: res}) => {
        setDataSatuan(res)
      })
      .catch(err => {
        console.log('Error get Data satuan', err.message)
      })
  }

  const fetchObatKode = async () => {
    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-racikan/getobatkode',
        QueryString.stringify({
          a: 'dk13',
          reg: 'dbdok',
          uid,
        })
      )
      .then(({data: res}) => {
        if (res) {
          setForm({...form, obatkode: res})
        } else {
          console.log('Error get Data Etiket')
        }
      })
      .catch(err => {
        console.log('Error get Data Etiket', err.message)
      })
  }

  const SatuanHargaObat = ({value = {}, index = 0}) => {
    return (
      <>
        <VmView className="w-full sm:flex gap-4">
          <VmView className="w-full mt-2">
            <label className="block text-gray-700 mb-1">
              {index === 0 ? 'Satuan Terkecil' : 'Satuan ' + (index + 1)}
            </label>
            <Controller
              name={`satuanObat[${index}].soid`}
              control={control}
              render={({field}) => (
                <select
                  {...field}
                  className="w-full p-2 rounded-xl focus:outline-none ring-1 ring-gray-300 focus:ring-blue-500 focus:ring-2 px-4"
                >
                  {dataSatuan
                    ?.filter(item => parseInt(item.soaktif) === 1)
                    .map((item, index) => (
                      <option value={item?.soid} key={`sat-${index}`}>
                        {item?.sonama}
                      </option>
                    ))}
                </select>
              )}
            />
          </VmView>
          <TextField
            name={`satuanObat[${index}][konversi]`}
            label="Konversi"
            type="number"
          />
        </VmView>
        <TextField
          name={`satuanObat[${index}][hna]`}
          label="HNA"
          type="number"
        />

        {[1, 2, 3].map((item, idx) => (
          <VmView className="w-full sm:flex gap-4" key={`itemharga-${idx}`}>
            <TextField
              name={`satuanObat[${index}][hj${item}]`}
              label={`Harga Jual ${item}`}
              type="number"
            />

            <TextField
              name={`satuanObat[${index}][diskon${item}]`}
              label={`Diskon Harga ${item}`}
              type="number"
            />
          </VmView>
        ))}

        <TextField
          name={`satuanObat[${index}][barcode]`}
          label="Barcode"
          type="text"
        />

        <VmView className="flex w-full mt-2 gap-4 justify-end">
          {index !== 0 && index + 1 === getValues('satuanObat').length && (
            <button
              type="button"
              className="p-2 rounded-xl bg-gray-200 hover:bg-gray-300"
              onClick={() =>
                reset({
                  ...getValues(),
                  satuanObat: getValues('satuanObat').filter(
                    (_, i) => i !== index
                  ),
                })
              }
            >
              Hapus
            </button>
          )}
          {index < 3 && index + 1 === getValues('satuanObat').length && (
            <button
              type="button"
              className="p-2 rounded-xl bg-blue-300 hover:bg-gray-300"
              onClick={() =>
                reset({
                  ...getValues(),
                  satuanObat: [...getValues('satuanObat'), defaultSatuanObat],
                })
              }
            >
              Tambah
            </button>
          )}
        </VmView>
      </>
    )
  }

  useEffect(() => {
    if (!!initialData) setForm(initialData)
    if (!initialData) fetchObatKode()
    fetchEtiket()
    fetchSatuan()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData])

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <VmView className="p-4">
          {/* Section Header */}
          <VmView className="bg-blue-500 text-white text-2xl font-semibold p-4 rounded-t-2xl">
            {label}
          </VmView>

          {/* Section body */}
          <VmView className="p-4 flex-1 border-x-2 border-b-2 border-gray-200 rounded-b-2xl rounded-x-2xl mb-16">
            {inputForm.map((field, index) => (
              <TextField key={index} openModal={openModal} {...field} />
            ))}
            <div className="h-2" />

            <label className="text-2xl">Detail Satuan</label>
            {getValues('satuanObat').map((item, index) => (
              <SatuanHargaObat
                key={`satobat-${index}`}
                value={item}
                index={index}
              />
            ))}
          </VmView>

          {/* Section Footer */}
          <VmView className="fixed bottom-0 left-0 w-full bg-white shadow-md p-4 flex justify-between">
            <button
              type="submit"
              disabled={loading}
              className={`success p-2 px-4 rounded-lg ${
                loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              Simpan
            </button>

            <button
              type="button"
              onClick={() => navigate('/prd-data-obat?dctid=' + uid)}
              className="danger-outline p-2 px-4 rounded-lg"
            >
              Batal
            </button>
          </VmView>

          <ProgressFullScreen visible={loading} />
          <AlertForm {...{...propsalertform, noText: false, yesText: 'Ok'}} />
          <ModalCariEtiket
            isOpen={isModalOpen}
            onClose={closeModal}
            items={dataEtiket}
            onSelectEtiket={item => {
              setValue('obatetiketcatatan', item.etiketerangan)
              closeModal()
            }}
          />
        </VmView>
      </form>
    </FormProvider>
  )
}
